<!-- src/components/AdvancedContactSearch.vue -->

<template>
    <div class="advanced-search">
        <details class="bg-white" :open="showAdvancedSearch">
      <summary
        class="
          list-none
          bg-gradient-to-r
          from-cal-009588
          to-cal-71AF2F
          text-white
          p-4
          uppercase
          cursor-pointer
        flex
          flex-row
          items-center
        "
      >
        <span>Advanced Search</span>
        <div class="search-toggle-icon"></div>
      </summary>
      <form class="p-2 lg:p-6 lg:space-y-4" @submit.prevent="$emit('search')">
        <div class="flex flex-col lg:flex-row lg:items-center gap-2 lg:gap-4">
            <div class="grow">
             <text-input v-model="params.name" name="name" label="Name" />
            </div>
          <div class="grow">
            <form-label>Company Type</form-label>
            <vue-multiselect
                class="mt-2"
                option-id="id"
                option-label="name"
                :options="options.companyTypes"
                v-model="params.companyType">
            </vue-multiselect>
          </div>
            <div class="grow">
              <form-label>State</form-label>
              <vue-multiselect
                  class="mt-2"
                  option-id="abbr"
                  option-label="name"
                  :options="options.states"
                  v-model="params.state">
              </vue-multiselect>
            </div>
            <div class="grow">
                <text-input v-model="params.zip" name="zip" label="Zip" />
            </div>
        </div>
        <div class="flex flex-col lg:flex-row lg:justify-between lg:items-center mt-2 lg:mt-4">
            <div class="lg:space-x-4 text-sm lg:flex lg:flex-row">
              <icon-button
                  :invert="true"
                  @click.native="showAddSaveSearch = true"
              >
                <slot slot="icon">
                  <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="12.326"
                      height="12.326"
                      viewBox="0 0 12.326 12.326"
                  >
                    <path
                        d="M11.445,7.092H7.483V3.13a.881.881,0,0,0-.88-.88h-.88a.881.881,0,0,0-.88.88V7.092H.88a.881.881,0,0,0-.88.88v.88a.881.881,0,0,0,.88.88H4.842V13.7a.881.881,0,0,0,.88.88H6.6a.881.881,0,0,0,.88-.88V9.733h3.962a.881.881,0,0,0,.88-.88v-.88A.881.881,0,0,0,11.445,7.092Z"
                        transform="translate(0 -2.25)"
                    />
                  </svg>
                </slot>
                <slot slot="label">Save search</slot>
              </icon-button>
              <icon-button
                  :invert="true"
                  @click.native="showSavedSearches = true"
              >
                <slot slot="icon">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512">
                    <path
                        d="M384 48V512l-192-112L0 512V48C0 21.5 21.5 0 48 0h288C362.5 0 384 21.5 384 48z"
                    />
                  </svg>
                </slot>
                <slot slot="label">Saved searches</slot>
              </icon-button>
                <icon-button :invert="true" @click.native="clear()">
                <slot slot="icon">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                    <path
                        d="M448 32C483.3 32 512 60.65 512 96V416C512 451.3 483.3 480 448 480H64C28.65 480 0 451.3 0 416V96C0 60.65 28.65 32 64 32H448zM175 208.1L222.1 255.1L175 303C165.7 312.4 165.7 327.6 175 336.1C184.4 346.3 199.6 346.3 208.1 336.1L255.1 289.9L303 336.1C312.4 346.3 327.6 346.3 336.1 336.1C346.3 327.6 346.3 312.4 336.1 303L289.9 255.1L336.1 208.1C346.3 199.6 346.3 184.4 336.1 175C327.6 165.7 312.4 165.7 303 175L255.1 222.1L208.1 175C199.6 165.7 184.4 165.7 175 175C165.7 184.4 165.7 199.6 175 208.1V208.1z"
                    />
                    </svg>
                </slot>
                <slot slot="label">Clear all fields</slot>
                </icon-button>
            </div>
            <primary-button @click.native="$emit('search')">Search</primary-button>
        </div>
      </form>
        </details>
      <vue-modal
          v-if="showAddSaveSearch"
          @close="showAddSaveSearch = false"
          size="small"
      >
        <div slot="header">
          <h3>Save Search</h3>
        </div>
        <div slot="body">
          <p class="my-1 align-middle text-sm">Give your saved search a custom name</p>
          <form class="my-2 space-y-6" @submit.prevent="saveSearch">
            <text-input name="saved_search_name" label="Saved search name" v-model="savedSearch.name" />
            <primary-button>Save search</primary-button>
          </form>
        </div>
        <div slot="footer"></div>
      </vue-modal>
      <vue-modal v-if="showSavedSearches" @close="showSavedSearches = false">
        <div slot="header">
          <h3>Saved Searches</h3>
        </div>
        <div slot="body" class="saved-searches">
          <p class="mb-1">Select a saved search to pre-fill fields</p>
          <li class="flex items-center justify-between" v-for="search in savedSearches" @click="loadSavedSearch(search)">
            <span>{{ search.name }}</span>
            <vue-button
                @click.stop="deleteSavedSearch(search)"
                type="red small"
                icon="icon-delete"
            >Delete</vue-button
            >
          </li>
        </div>
        <div slot="footer"></div>
      </vue-modal>
    </div>
</template>

<script>

import SegmentedControl from './../SegmentedControl.vue';
import VueMultiselect from './../VueMultiselect.vue';
import WebServices from '../../../services/WebServices';
import VueButton from './../VueButton.vue';
import FormLabel from '../../Form/FormLabel.vue';
import PrimaryButton from "../../Form/PrimaryButton";
import TextInput from "../../Form/TextInput";
import IconButton from './../IconButton.vue';
import VueModal from "./../VueModal.vue";

export default {

    components: {VueModal, SegmentedControl, VueMultiselect, WebServices, VueButton, FormLabel, PrimaryButton, TextInput, IconButton },

    props: [ "value" ],

    data () {
        return {
            options: {
                states: [],
                companyTypes: []
            },
            params: {
                name: "",
                address1: "",
                address2: "",
                city: "",
                state: [],
                zip: "",
                companyType: []
            },
            showAdvancedSearch: false,
          showAddSaveSearch: false,
          showSavedSearches: false,
          savedSearch: {},
          savedSearches: [],
        }
    },

    created () {

        this.getAdvancedOptions();
      this.getSavedSearches();
        this.params = Object.assign({}, this.params, this.value);
    },

    methods: {

        clear () {
            this.$root.$emit('CompaniesView');
            this.$root.$emit('AdminCompaniesView');

            this.params = {
                name: "",
                address1: "",
                address2: "",
                city: "",
                state: [],
                zip: '',
                companyType: []
            };

            this.$emit('input', this.params);
            this.$emit('search')
        },

        getAdvancedOptions () {
            var services = WebServices("Companies");
            services
                .getAll({}, "AdvancedOptions")
                .then((response) => {

                    var data = response.data.data;
                    this.options.states = data.states;
                    this.options.companyTypes = data.companyTypes;

                }, (response) => {
                    // error callback
                    console.log(response);
                });
        },
      getSavedSearches() {
        const services = WebServices("Users/Me/SavedCompanySearches");
        services.get({}).then(
            (response) => {
              this.savedSearches = response.data.data;
            },
            (response) => {
              // error callback
              console.log(response);
            }
        );
      },

      saveSearch() {
        this.savedSearch.search = JSON.stringify(this.params);

        const services = WebServices("Users/Me/SavedCompanySearches");
        services.store(this.savedSearch).then(
            () => {
              this.savedSearch = {};
              this.showAddSaveSearch = false;
              this.getSavedSearches();
            },
            (response) => {
              // error callback
              console.log(response);
            }
        );
      },

      loadSavedSearch(savedSearch) {
        const params = JSON.parse(savedSearch.search);
        this.params = Object.assign({}, this.params, params);
        this.showSavedSearches = false;
        this.$emit('input', this.params);
        this.$emit('search')
      },

      deleteSavedSearch(savedSearch) {
        const services = WebServices("Users/Me/SavedCompanySearches");
        services.remove(savedSearch.id).then(
            () => this.getSavedSearches(),
            (response) => console.log(response)
        );
        return false;
      },

    },

    watch: {

        params: {
            handler: function (val, oldVal) {
                this.$emit('input', this.params);
            },
            deep: true
        }
    }
}
</script>
